import { render, staticRenderFns } from "./company-money.vue?vue&type=template&id=71791f54&"
import script from "./company-money.vue?vue&type=script&lang=js&"
export * from "./company-money.vue?vue&type=script&lang=js&"
import style0 from "./company-money.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports